module.exports = __webpack_public_path__ + "lady-2.svg?66726e674ff4de967ac3f3dcda78a562";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lady-2.svg
// module id = 58
// module chunks = 0